import React, { useState, useRef, useEffect } from 'react';
import { Flex, View } from '@instructure/ui';
import {
  getStore,
  usePlayerStore,
  useAppStore,
} from '../../../stores/StoreContext';
import Playhead from './Playhead';
import ProgressBar from './ProgressBar';
import AnnotationMarkers from './Annotations/AnnotationMarkers';
import CONSTANTS from '../../../config/constants';
function Timeline({ defaultTime, onSeek }) {
  const PlayerStore = getStore('playerStore');
  const LayoutStore = getStore('layoutStore');
  const AppStore = getStore('appStore');
  const containerRef = useRef(null);
  const playbackProgressBarRef = useRef(null);

  const [dragging, setDragging] = useState(false);
  const [contextMenuMountNode, setContextMenuMountNode] = useState();
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [duration, setDuration] = useState();
  const [currentTime, setCurrentTime] = useState();
  const [pausedDueToTimelineHover, setPausedDueToTimelineHover] =
    useState(false);

  const isLive = usePlayerStore((state) => state.isLive);
  const playing = usePlayerStore((state) => state.playing);

  useEffect(() => {
    // If the session is not live, go ahead and set the times...
    if (!isLive) {
      setCurrentTime(PlayerStore.currentTime);
      setDuration(PlayerStore.duration);
    }
  }, [isLive]);

  useEffect(() => {
    // If the session is not live, go ahead and set the times...
    if (playbackProgressBarRef.current) {
      LayoutStore.setPlaybackProgressBarRef(playbackProgressBarRef.current);
    }
  }, [playbackProgressBarRef]);

  const handleMouseEnter = () => {
    if (playing) {
      setPausedDueToTimelineHover(true);
      PlayerStore.setPlaying(false);
    }
  };

  const handleMouseLeave = () => {
    if (pausedDueToTimelineHover) {
      PlayerStore.setPlaying(true);
    }
  };

  const handleCommmentClick = (time) => {
    setCurrentTime(time);
    onSeek(time);
  };

  useEffect(() => {
    if (isLive) {
      PlayerStore.setCurrentTime(duration);
      setCurrentTime(duration);
    }
  }, [duration]);

  const containerStyle = {
    position: 'relative',
    width: '100%',
  };

  return (
    <>
      <Flex as="div" withVisualDebug={false} gap="small" alignItems="center">
        <Flex.Item
          as="div"
          shouldGrow
          alignItems="center"
          withVisualDebug={false}
          id="video-scrub-bar"
        >
          <div
            id="timeline-wrapper"
            ref={containerRef}
            style={containerStyle}
          //onMouseMove={handleMouseMove}
          //onMouseUp={handleMouseUp}
          //onMouseEnter={handleMouseEnter}
          //onMouseLeave={handleMouseLeave}
          //onClick={handleClickNav}
          >
            <View
              as="div"
              className="video-playback-progress-bar"
              position="relative"
              height="40px"
              padding="small none none none"
              themeOverride={{
                paddingSmall: '17px',
              }}
              elementRef={(el) => {
                playbackProgressBarRef.current = el;
              }}
            >
              <ProgressBar ref={containerRef} />
              <Playhead ref={containerRef} />
            </View>
            <AnnotationMarkers />
          </div>
        </Flex.Item>
      </Flex>
    </>
  );
}

export default Timeline;
